<template>
  <div class="lgc__form-w">
    <div class="lgc__type">
      <div class="type__block">
        <label class="radio-container">
          <input
            v-model="isAdmLogin"
            :class="['user', !isAdmLogin ? '--active' : '']"
            :value="false"
            type="radio"
            :checked="!isAdmLogin"
          />
          <span class="radio-checkmark"></span>
          Usuário
        </label>
      </div>
      <div class="type__block">
        <label class="radio-container">
          <input
            v-model="isAdmLogin"
            :class="['user', isAdmLogin ? '--active' : '']"
            :value="true"
            type="radio"
            :checked="isAdmLogin"
          />
          <span class="radio-checkmark"></span>
          Administrador
        </label>
      </div>
    </div>
    <div class="lgc__form-c">
      <ValidationMessage v-show="loginState === false">{{ messageError }}</ValidationMessage>

      <InputText
        v-if="!isAdmLogin"
        key="field-org"
        :vmodel.sync="company"
        field-label="Organização"
        field-placeholder="Digite sua organização"
        :state="loginState"
      />

      <InputText
        v-if="!isAdmLogin"
        key="field-username"
        :vmodel.sync="userName"
        field-label="Usuário"
        field-placeholder="Digite seu usuario"
        :state="loginState"
      />
      <InputText
        v-if="isAdmLogin"
        key="field-email"
        :vmodel.sync="email"
        field-label="E-mail"
        field-placeholder="Digite seu e-mail"
        :state="loginState"
      />

      <InputText
        input-i-d="password-input"
        :vmodel.sync="password"
        field-label="Senha"
        field-placeholder="Digite sua senha"
        :state="loginState"
        input="password"
      />

      <div class="lgc__checkbox-c">
        <Checkbox
          checkbox-text="Lembrar-me"
          :checkbox-value.sync="checkboxValue"
        />
        <span
          class="lgc__recover-password"
          @click="redirectToForgotPage"
          >Esqueceu sua senha?</span
        >
      </div>
    </div>

    <ButtonFullWidth
      class="btn-enter"
      :disabled="disabledButton"
      @click="login"
    >
      <div slot="text">Entrar</div>
    </ButtonFullWidth>
  </div>
</template>

<script>
  import ValidationMessage from '@/views/authentication/components/card-layout/components/validation-message';
  import InputText from '@/components/input-text';
  import ButtonFullWidth from '@/components/buttons/button-full-width';
  import Checkbox from '@/components/checkbox';
  import useJwt from '@/auth/mainJwt';
  import { BFormRadio } from 'bootstrap-vue';
  import { mapActions, mapMutations } from 'vuex';

  export default {
    name: 'LoginForm',
    components: {
      ValidationMessage,
      InputText,
      ButtonFullWidth,
      Checkbox,
      BFormRadio
    },
    data: () => ({
      prefix: '',
      company: '',
      userName: '',
      email: '',
      password: '',
      temporaryToken: '',
      siteId: '',
      currentGuid: '',
      isAdmLogin: false,
      loginState: null,
      checkboxValue: false,
      disabledButton: false,
      messageError: 'Credenciais inválidas'
    }),
    mounted() {
      this.blockCopyAndPasteInPasswordInput();
      this.setEventListenerKeydown();
    },
    methods: {
      ...mapActions('userStore', ['setUser']),
      ...mapActions('auth', ['fetchPermissions']),
      ...mapMutations('appStore', ['UPDATE_PERMISSIONS_MODULES']),

      blockCopyAndPasteInPasswordInput() {
        const input = document.querySelector('#password-input');
        if (input) {
          input.addEventListener('paste', (e) => e.preventDefault());
          input.addEventListener('copy', (e) => e.preventDefault());
        }
      },
      clearFields() {
        this.company = '';
        this.userName = '';
        this.email = '';
        this.password = '';
      },
      handleCreateAbility(permissions) {
        const mySfcModules =
          permissions?.find((system) => system.name.toLowerCase() === 'mysfc')?.modules ?? [];
        const ability = [
          { action: 'read', subject: 'basic' },
          { action: 'read', subject: 'integration' }
        ];
        if (mySfcModules.includes('pcp')) ability.push({ action: 'read', subject: 'pcp' });
        if (mySfcModules.includes('operator'))
          ability.push({ action: 'read', subject: 'operator' });
        if (mySfcModules.includes('pcp') && mySfcModules.includes('operator')) {
          ability.push({ action: 'manage', subject: 'all' });
        }
        return ability;
      },
      validateFields() {
        const { company, userName, email, password } = this;
        const validate = !company || !userName || !password ? false : null;
        const validateADM = !email || !password || !this._validateEmail(email) ? false : null;
        const typeValidate = this.isAdmLogin ? validateADM : validate;
        this.loginState = typeValidate;
        return typeValidate === null;
      },
      async login() {
        if (!this.validateFields()) {
          this.messageError = 'Credenciais inválidas';
          return;
        }

        let prefix = !this.isAdmLogin ? this.company.toLowerCase() : null;
        this.disabledButton = true;
        this._showLoading();

        const payload = this.isAdmLogin
          ? { email: this.email, password: this.password, remember: true }
          : { company: this.company, username: this.userName, password: this.password };

        let keepLogin = true;
        let passwordChangeRequired = false;
        let pinChangeRequired = false;

        let fullSitesList = [];

        try {
          const response = await this.$http2.post(
            `api/login${this.isAdmLogin ? '/administrator' : ''}`,
            payload
          );

          this.temporaryToken = response.data.data.token;

          fullSitesList = response.data.data.sites || [];

          this.siteId = fullSitesList[0]?.id ?? '';
          this.currentGuid = fullSitesList[0] ?? '';

          passwordChangeRequired = response.data.data.passwordChangeRequired;
          pinChangeRequired = response.data.data.pinChangeRequired;
          prefix = response.data?.data?.company ?? '';

          const domain = window.location.href.includes('indsiders.com');
          this.$cookies.set('company', prefix, '7D', null, domain ? 'indsiders.com' : null);
          localStorage.setItem('prefix', prefix);
        } catch (error) {
          const userNotAdmId = 102;
          if (error.response?.data?.errors) {
            error.response.data.errors.forEach((e) => {
              if (e.id === userNotAdmId) {
                this.messageError =
                  'Você não possui este acesso. Por favor, entre em contato com o seu administrador';
              }
            });
          }
          keepLogin = false;
          this.disabledButton = false;
          this.loginState = false;
          this._hideLoading();
          return;
        }

        if (keepLogin) {
          try {
            const response = await useJwt.login({
              email: this.isAdmLogin ? this.email : this.userName,
              password: this.password,
              prefix: prefix,
              remember: this.checkboxValue
            });

            const loginData = response.data;
            const userData = response.data.userData;

            if (fullSitesList.length > 0) {
              userData.sites = fullSitesList;
            }

            userData.permissions = userData.permissions.systems;
            userData.ability = this.handleCreateAbility(userData?.permissions);

            const infoAccount = {
              guid: userData.guid,
              employee_id: userData.employee_id,
              first_name: userData.first_name,
              last_name: userData.last_name,
              job_role: userData.job_role,
              photo: userData.photo
            };

            this.setUser({
              ...userData,
              name: `${infoAccount.first_name} ${infoAccount.last_name}`,
              role: infoAccount.job_role,
              picture: infoAccount.photo
            });

            const domain = window.location.href.includes('indsiders.com');
            const multipleAccount = this.$route.name === 'multiple-account';

            localStorage.setItem('accessToken', response.data.accessToken);

            localStorage.setItem('userData', JSON.stringify(userData));

            let loggedAccounts = [];
            try {
              loggedAccounts = JSON.parse(localStorage.getItem('loggedAccountsInfo')) || [];
            } catch (e) {
              loggedAccounts = [];
            }

            const userIndex = loggedAccounts.findIndex(
              (item) => item.guid == response.data.userData.guid
            );
            if (userIndex === -1) {
              loggedAccounts.unshift(infoAccount);
              localStorage.setItem('loggedAccountsInfo', JSON.stringify(loggedAccounts));
            }

            const userDataForCookie = JSON.parse(JSON.stringify(userData));

            if (userDataForCookie.permissions) delete userDataForCookie.permissions;

            this.$cookies.set(
              'userInfo',
              {
                ...loginData,
                currentSite: this.siteId,
                currentGuid: this.currentGuid,
                temporaryToken: this.temporaryToken,
                passwordChangeRequired,
                pinChangeRequired,
                language: 'pt-BR',
                userData: userDataForCookie
              },
              '7D',
              null,
              domain ? 'indsiders.com' : null
            );

            await this.fetchPermissions();

            if (multipleAccount) {
              window.location.href = this.$mySfcLink;
            } else {
              this.$router
                .push({
                  name: 'home',
                  params: { prefix }
                })
                .catch(() => {});
            }

            this.disabledButton = false;
            if (!multipleAccount) this._hideLoading();
          } catch (error) {
            this.disabledButton = false;
            this.loginState = false;
            this._hideLoading();
            console.error(error);
          }
        }
      },
      redirectToForgotPage() {
        this.$router.push({ name: 'forgot' }).catch(() => {});
      },
      setEventListenerKeydown() {
        window.addEventListener('keydown', this.loginPerKeydown);
      },
      removeEventListenerKeydown() {
        window.removeEventListener('keydown', this.loginPerKeydown);
      },
      loginPerKeydown({ key }) {
        key === 'Enter' && this.login();
      }
    },
    watch: {
      isAdmLogin() {
        this.loginState = null;
        this.messageError = 'Credenciais inválidas';
        this.clearFields();
      }
    },
    destroyed() {
      this.removeEventListenerKeydown();
      this._hideLoading();
    }
  };
</script>

<style lang="scss" scoped>
  .lgc__form-w {
    width: 100%;
    border-top: 1px solid #eeeeee;

    .lgc__type {
      display: flex;
      gap: 16px;

      .type__block {
        width: 100%;
        display: flex;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        border-radius: 6px;
        border: 1px solid #cfc4be;

        .radio-container {
          cursor: pointer;
          display: flex;
          align-items: center;
          color: #4c4541;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          margin-bottom: 0;
          width: 100%;
          height: 100%;
          padding: 15px 16px;

          input[type='radio'] {
            display: none;

            &:checked + .radio-checkmark {
              background-color: #fff;
              border-color: #974900;
            }

            &:checked + .radio-checkmark:after {
              display: block;
            }
          }

          .radio-checkmark {
            width: 18px;
            height: 18px;
            background-color: #fff;
            border-radius: 50%;
            position: relative;
            display: inline-block;
            margin-right: 10px;
            border: 1px solid #cfc4be;

            &:after {
              content: '';
              position: absolute;
              display: none;
              left: 2px;
              top: 2px;
              width: 12px;
              height: 12px;
              border: solid #974900;
              border-radius: 50%;
              background-color: #974900;
            }
          }
        }

        &:has(.--active) {
          border: 1px solid #974900;
        }
      }
    }

    .lgc__form-c {
      gap: 16px;
      margin: 16px 0 32px;

      display: flex;
      flex-direction: column;

      .lgc__checkbox-c {
        display: flex;
        justify-content: space-between;

        .lgc__recover-password {
          padding: 0px 14px;
          color: #974900;
          font-size: 12px;
          font-weight: 600;
          line-height: 20px;
          letter-spacing: 0.15px;
          user-select: none;
          cursor: pointer;
        }
      }
    }
  }

  @media (max-width: 485px) {
    .lgc__form-w {
      .lgc__type {
        flex-direction: column;
      }
      .lgc__form-c {
        .lgc__checkbox-c {
          .lgc__recover-password {
            padding: 4px 14px !important;
            font-size: 12px !important;
            line-height: 20px !important;
          }
        }
      }
    }
  }
</style>
